import { initFaroDependencies } from 'App/services/faroService';
import { initDeviceId } from "Shared/services/deviceId";
import { initDeviceCookie } from "Shared/services/deviceService";

/**
 * This file is for any global code that needs to always be executed on page load
 */
initDeviceId();
initDeviceCookie();
initFaroDependencies();